/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Campaigns_TitleInputs */



/**
* | output |
* | --- |
* | "Discord giveaways" |
*
* @param {Meta_Campaigns_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const meta_campaigns_title = /** @type {((inputs?: Meta_Campaigns_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Campaigns_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Розыгрыши в Discord")
	return /** @type {LocalizedString} */ ("Discord giveaways")
});